import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, MouseEventHandler, PropsWithChildren } from 'react';

import { IGraphicSize } from '@gem/models/commonModel';
import { RemoteImage } from '@gem/modules/remote-storage';

import { useImagePreviewPresenter } from './ImagePreview.presenter';
import styles from './ImagePreview.styles.m.css';

interface IImagePreviewProps {
  className?: string;
  imageClassName?: string;
  url: string;
  graphicSize: IGraphicSize;
  maxWidth?: number;
  maxHeight?: number;
  placeholderQuality?: number;
  needCropImage?: boolean;
  isPreview?: boolean;
  isView?: boolean;
  isLocal?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
}

export const ImagePreview: FC<PropsWithChildren<IImagePreviewProps>> = observer((props) => {
  const { className, imageClassName, onClick, children } = props;
  const presenter = useImagePreviewPresenter(props);

  return (
    <div
      role="button"
      tabIndex={0}
      className={classNames(styles.container, className)}
      style={presenter.resizedImage.placeholderStyle}
      onClick={onClick}
    >
      {presenter.hasPlaceholder && (
        <RemoteImage
          isAnimatedReveal
          className={classNames(styles.placeholder, styles.hidden)}
          src={presenter.placeholderUrl}
          alt=""
        />
      )}

      <RemoteImage
        isAnimatedReveal
        width={presenter.resizedImage.imageSize.width}
        height={presenter.resizedImage.imageSize.height}
        className={classNames(styles.image, styles.hidden, imageClassName)}
        style={presenter.resizedImage.imageStyle}
        src={presenter.imageUrl}
        alt=""
      />

      {children}
    </div>
  );
});
